module.exports = __webpack_public_path__ + "img/iq.563968a0.svg";